import state from './moduleMessageTemplateState'
import actions from './moduleMessageTemplateActions'
import getters from './moduleMessageTemplateGetters'
import mutations from './moduleMessageTemplateMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
